import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import {
  getPoolMasterClass,
  getPoolProduct,
} from '../../../../../ECoSystemsHelper';
import { P00042 } from '../../../P00042';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { P00032 } from '../../../P00032';
import { P0003600 } from '../../../P0003600';
import { P0004700 } from '../../../P0004700';
import { P00046 } from '../../../P00046';
import { P0003601 } from '../../../P0003601';
import { P00058 } from '../../../P00058';
import { P0006600 } from '../../../P0006600';

export function P00076ConstanceMiseEnOeuvreInit(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
  getValue: any,
  additionalData: PoolAdditionalData,
): boolean {
  const master = getPoolMasterClass(pool);
  const product = getPoolProduct(pool, productClass);
  const produitP00042 = master?.hasProduct(pool, new P00042()) ?? 0;
  let force = false;

  const currentcoIActivationVoletImmerge = getValue(
    'coIActivationVoletImmerge',
    productClass,
  );
  if (produitP00042 > 0 && currentcoIActivationVoletImmerge === 0) {
    editValue(
      P00039DataRxTxIndex.Constance_Installation,
      'coIActivationVoletImmerge',
      1,
      null,
    );
  }

  let produitP00032 = master?.hasProduct(pool, new P00032()) ?? 0;
  if (getValue('snIInstallationCapteurDebit', new P00032()) !== 1) {
    produitP00032 = 0;
  }

  const produitP0003600 = master?.hasProduct(pool, new P0003600()) ?? 0;
  const produitP0004700 = master?.hasProduct(pool, new P0004700()) ?? 0;
  const produitP00046 = master?.hasProduct(pool, new P00046()) ?? 0;
  const produitP0003601 = master?.hasProduct(pool, new P0003601()) ?? 0;
  const produitP00058 = master?.hasProduct(pool, new P00058()) ?? 0;
  const produitP0006600 = master?.hasProduct(pool, new P0006600()) ?? 0;

  let sourceReferenceDebit = 0;

  if (produitP0003600 > 0 || produitP0004700 > 0) {
    sourceReferenceDebit = 2;
  } else if (produitP0003601 > 0 || produitP00046 > 0) {
    sourceReferenceDebit = 3;
  } else if (produitP00058 > 0 || produitP0006600 > 0) {
    sourceReferenceDebit = 4;
  } else if (produitP00032 > 0) {
    sourceReferenceDebit = 1;
  }

  const currentSourceReferenceDebit = getValue(
    'coISourceReferenceDebit',
    productClass,
  );

  if (sourceReferenceDebit != currentSourceReferenceDebit) {
    editValue(
      P00039DataRxTxIndex.InjectionChlore_Installation,
      'coISourceReferenceDebit',
      currentSourceReferenceDebit,
      null,
      productClass,
    );
  }

  return force;
}
